'use strict';

function SituatieKaart(htmlElements, options) {
	this.htmlElements = htmlElements;

	this.viewerElement = null;
	this.currentElement = null;
	this.closeInfoWindowElement = null;
	this.currentContentElement = null;
	this.currentLayout;

	//default options
	this.options = {
		'showLegenda': true,
		'layoutSwitchWidth': 1056,
		'showPopup': false,
		'showDocuments': false,
		'fields': ['bouwnummer', 'woningsoort', 'kaveloppervlakte', 'prijs', 'status'],
		'fieldsPopup': ['bouwnummer', 'woningsoort', 'kaveloppervlakte', 'woningoppervlakte', 'balkonoppervlakte', 'inhoud', 'prijs', 'status']
	};

	//voeg input opties samen met default opties
	for (var attrname in options) {
		this.options[attrname] = options[attrname];
	}

	this.bouwnummers = [];

	// bind functions
	this.activateInfoWindow = this.activateInfoWindow.bind(this);
	this.deactivateInfoWindow = this.deactivateInfoWindow.bind(this);
	this.setupKaart = this.setupKaart.bind(this);
	this.setInfoWindow = this.setInfoWindow.bind(this);
	this.openFullInfoWindow = this.openFullInfoWindow.bind(this);
	this.changeLegenda = this.changeLegenda.bind(this);
	this.removeFullInfoWindow = this.removeFullInfoWindow.bind(this);
	this.onResizeLayout = this.onResizeLayout.bind(this);
	this.openViewer = this.openViewer.bind(this);
	this.removeViewer = this.removeViewer.bind(this);

	this.setLoadingStatus();

	this.parseKavels = this.parseKavels.bind(this);
	this.parseKavelsRequest = new XMLHttpRequest();
	this.parseKavelsRequest.addEventListener('readystatechange', this.parseKavels);

	var url = ajax_url_get_kavels;

	this.parseKavelsRequest.open('POST', url);
	this.parseKavelsRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

	this.parseKavelsRequest.send();
}

SituatieKaart.prototype.setLoadingStatus = function () {
	this.htmlElements.kaartElement.classList.add('is-loading');
	this.htmlElements.mapElement.classList.add('is-loading');
};

SituatieKaart.prototype.removeLoadingStatus = function () {
	this.htmlElements.kaartElement.classList.remove('is-loading');
	this.htmlElements.mapElement.classList.remove('is-loading');
};

SituatieKaart.prototype.setSvgLabel = function (element, bouwnummer) {
	if (!element || element.nodeType !== 1) {
		return;
	}

	while (element.firstChild) {
		element.removeChild(element.firstChild);
	}

	element.appendChild(document.createTextNode(bouwnummer.data.bouwnummer));
};

SituatieKaart.prototype.activateInfoWindow = function () {
	this.infoWindowElement.classList.add('is-active');
};

SituatieKaart.prototype.deactivateInfoWindow = function () {
	this.infoWindowElement.classList.remove('is-active');
};

SituatieKaart.prototype.parseKavels = function () {
	if (this.parseKavelsRequest.readyState != 4) return;
	if (this.parseKavelsRequest.status != 200 && this.parseKavelsRequest.status != 304) {
		console.log('HTTP error ' + this.parseKavelsRequest.status);
		return;
	}

	if (!this.parseKavelsRequest.responseText) {
		console.error('Kan kavel data niet ophalen');
	}

	this.removeLoadingStatus();

	var kavelData = JSON.parse(this.parseKavelsRequest.responseText);
	var kavelElements = this.htmlElements.mapElement.getElementsByTagName('a');

	var aKavelNo = false;
	var iKavelNo = false;

	for (var i = 0; i < kavelElements.length; i++) {
		for (var j = 0; j < kavelData.length; j++) {
			if (kavelElements[i].getAttribute('data-kavel')) {
				aKavelNo = kavelElements[i].getAttribute('data-kavel').toLowerCase();
			} else {
				aKavelNo = false;
			}
			if (kavelData[j].bouwnummer) {
				iKavelNo = kavelData[j].bouwnummer.toLowerCase();
			} else {
				iKavelNo = false;
			}
			if (aKavelNo && iKavelNo && aKavelNo === iKavelNo) {
				this.bouwnummers.push({
					'data': kavelData[j],
					'element': kavelElements[i]
				});
			}
		}
	}

	for (var _i = 0; _i < this.bouwnummers.length; _i++) {
		this.bouwnummers[_i].element.setAttribute('class', this.bouwnummers[_i].data.status.toLowerCase().replace(/\s+/g, '-').replace(/\(/g, '').replace(/\)/g, ''));
		this.bouwnummers[_i].element.setAttribute('data-status', this.bouwnummers[_i].data.status.toLowerCase());

		if (this.options.lotsStatusActive) {
			this.bouwnummers[_i].element.setAttribute('class', this.bouwnummers[_i].element.getAttribute('class') + ' is-active');
		}

		// search for label elements
		var textElement = this.bouwnummers[_i].element.querySelector('.s-popup-bouwnummer text');
		if (textElement) {
			this.setSvgLabel(textElement, this.bouwnummers[_i]);
		}
	}

	this.bouwnummers.sort(function (a, b) {
		var c = parseInt(a.data.bouwnummer);
		var d = parseInt(b.data.bouwnummer);

		if (c < d) {
			return -1;
		}
		if (c > d) {
			return 1;
		}

		return 0;
	});

	this.setupKaart();
};

SituatieKaart.prototype.setupKaart = function (e) {
	this.htmlElements.mapElement.addEventListener('click', this.setInfoWindow);

	if (this.options.showPopup) {
		this.fullInfoWindowElement = document.createElement('div');
		this.fullInfoWindowElement.setAttribute('class', 'kavelkaart-fullinfowindow');
		this.fullInfoWindowBackgroundElement = document.createElement('div');
		this.fullInfoWindowBackgroundElement.setAttribute('class', 'kavelkaart-fullinfowindow-background');
		this.fullInfoWindowBackgroundElement.addEventListener('click', this.removeFullInfoWindow);

		document.body.appendChild(this.fullInfoWindowElement);
		document.body.appendChild(this.fullInfoWindowBackgroundElement);
	}

	if (this.htmlElements.kaartElement.nodeName == 'A') {
		this.htmlElements.kaartElement.setAttribute('data-href', this.htmlElements.kaartElement.getAttribute('href'));
		this.htmlElements.kaartElement.removeAttribute('href');
	}

	if (window.innerWidth && window.innerWidth < this.options.layoutSwitchWidth) {
		this.currentLayout = 'small';
		this.htmlElements.kaartElement.addEventListener('click', this.openViewer);
	} else {
		this.currentLayout = 'large';

		this.openViewer();
	}

	window.addEventListener('resize', this.onResizeLayout); //voor dynamisch switch layout

	document.addEventListener('keydown', function (e) {
		if (e.keyCode == 27) {
			this.removeViewer(e);
		}
	}.bind(this), false);

	if (this.bouwnummers[0] && this.currentLayout === 'large' && this.options.showBuildNumberWindow) {
		this.updateSelectedState(this.bouwnummers[0].element);
		this.fillInfoWindow(this.bouwnummers[0].data);
		this.activateInfoWindow();
	}
};

// TODO: no event als argument!
SituatieKaart.prototype.setInfoWindow = function (e) {
	if (e && e.target) {
		var target = e.target;
	} else if (e && e.srcElement) {
		var target = e.srcElement;
	}

	while (target.nodeName.toLowerCase() != 'a') {
		if (target == this.infoWindowElement) {
			return;
		}
		if (target == this.htmlElements.mapElement || target == this.closeInfoWindowElement) {
			this.deactivateInfoWindow();
			this.updateSelectedState();
			return;
		}
		target = target.parentNode;
	}

	var kavelNo = target.getAttribute('data-kavel').toLowerCase();
	var kavelNoFound = false;
	for (var i = 0; i < this.bouwnummers.length; i++) {
		if (this.bouwnummers[i].data.bouwnummer) {
			var infoKavelNo = this.bouwnummers[i].data.bouwnummer.toLowerCase();
		}
		if (infoKavelNo && kavelNo === infoKavelNo) {
			this.fillInfoWindow(this.bouwnummers[i].data);
			kavelNoFound = true;
		}
	}

	if (kavelNoFound === false) {
		this.fillInfoWindow(false);
	}

	this.updateSelectedState(target);

	this.activateInfoWindow();
};

SituatieKaart.prototype.updateSelectedState = function (kavelElement) {
	for (var i = 0; i < this.bouwnummers.length; i++) {
		if (kavelElement && kavelElement == this.bouwnummers[i].element) {
			if (this.bouwnummers[i].element.classList) {
				//IE doesn't support classList in svg (?)
				this.bouwnummers[i].element.classList.add('is-selected');
			} else {
				if (this.bouwnummers[i].element.getAttribute('class')) {
					this.bouwnummers[i].element.setAttribute('class', this.bouwnummers[i].element.getAttribute('class') + ' is-selected');
				} else {
					this.bouwnummers[i].element.setAttribute('class', 'is-selected');
				}
			}
		} else {
			if (this.bouwnummers[i].element.classList) {
				//IE doesn't support classList in svg (?)
				this.bouwnummers[i].element.classList.remove('is-selected');
			} else {
				if (this.bouwnummers[i].element.getAttribute('class')) {
					this.bouwnummers[i].element.setAttribute('class', this.bouwnummers[i].element.getAttribute('class').replace(/ is-selected/, ''));
				}
			}
		}
	}
};

//TODO: function to long, needs refactor
SituatieKaart.prototype.fillInfoWindow = function (kavel) {
	while (this.infoWindowElement.firstChild) {
		this.infoWindowElement.removeChild(this.infoWindowElement.firstChild);
	}

	var image = kavel.image ? kavel.image : kavel.woningtypeImage;

	if (image && window.innerWidth && window.innerWidth >= this.options.layoutSwitchWidth) {
		var imgElement = document.createElement('img');
		imgElement.setAttribute('src', image.url);

		if (kavel.woningtypeUrl) {
			var aElementImage = document.createElement('a');
			aElementImage.setAttribute('href', kavel.woningtypeUrl);
			aElementImage.setAttribute('class', 'woningtype');

			aElementImage.appendChild(imgElement);
			this.infoWindowElement.appendChild(aElementImage);
		} else {
			imgElement.setAttribute('class', 'woningtype');
			this.infoWindowElement.appendChild(imgElement);
		}
	}

	var innerContentElement = document.createElement('div');
	innerContentElement.setAttribute('class', 'infowindow-inner');

	if (kavel == false) {
		var h2Element = document.createElement('h2');
		h2Element.appendChild(document.createTextNode('Deze woning is nog niet in verkoop gegaan of is al verkocht.'));
		this.infoWindowElement.appendChild(h2Element);
		return;
	}

	var tableElement = document.createElement('table');

	var h2Element = document.createElement('h2');
	h2Element.appendChild(document.createTextNode(kavel.titel));

	innerContentElement.appendChild(h2Element);

	if (kavel.bouwnummer && this.options.fields.indexOf('bouwnummer') >= 0) {
		tableElement.appendChild(this.createInfoRow('Bouwnummer', kavel.bouwnummer));
	}
	if (kavel.woningtype) {
		tableElement.appendChild(this.createInfoRow('Woningtype', kavel.woningtype));
	}

	if (kavel.woningsoort && this.options.fields.indexOf('woningsoort') >= 0) {
		tableElement.appendChild(this.createInfoRow('Woningsoort', kavel.woningsoort));
	}

	if (kavel.kaveloppervlakte && this.options.fields.indexOf('kaveloppervlakte') >= 0) {
		var elementArray = [];
		var supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('2'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Kaveloppervlakte', kavel.kaveloppervlakte, false, elementArray));
	}
	if (kavel.woonoppervlakte && this.options.fields.indexOf('woonoppervlakte') >= 0) {
		var elementArray = [];
		var supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('2'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Woonoppervlakte', kavel.woonoppervlakte, false, elementArray));
	}
	if (kavel.gebruiksoppervlakte && this.options.fields.indexOf('gebruiksoppervlakte') >= 0) {
		var elementArray = [];
		var supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('2'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Gebruiksoppervlakte', kavel.gebruiksoppervlakte, false, elementArray));
	}
	if (kavel.inhoud && this.options.fields.indexOf('inhoud') >= 0) {
		var elementArray = [];
		var supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('3'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Inhoud', kavel.inhoud, false, elementArray));
	}
	if (kavel.status && this.options.fields.indexOf('status') >= 0) {
		tableElement.appendChild(this.createInfoRow('Status', kavel.status, false, false, kavel.status.replace(/ /gi, '_')));
	}

	innerContentElement.appendChild(tableElement);

	if (kavel.prijsVan && kavel.prijsTot && this.options.fields.indexOf('prijsbereik') >= 0) {
		var prijsElement = document.createElement('span');
		prijsElement.setAttribute('class', 'infowindow-prijs');
		prijsElement.appendChild(document.createTextNode('€ ' + kavel.prijsVan + ',- - € ' + kavel.prijsTot + ',-'));
		innerContentElement.appendChild(prijsElement);
	} else if (parseInt(kavel.prijs) > 0 && this.options.fields.indexOf('prijs') >= 0) {
		var prijsElement = document.createElement('span');
		prijsElement.setAttribute('class', 'infowindow-prijs');
		prijsElement.appendChild(document.createTextNode('€ ' + kavel.prijs + ',-'));
		innerContentElement.appendChild(prijsElement);
	} else if (kavel.extra) {
		//hardcoding
		var prijsElement = document.createElement('span');
		prijsElement.setAttribute('class', 'infowindow-prijs');
		prijsElement.appendChild(document.createTextNode(kavel.extra));
		innerContentElement.appendChild(prijsElement);
	}

	if (this.options.showPopup) {
		var woningtypeButtonElement = document.createElement('button');
	} else if (kavel.woningtypeUrl) {
		var woningtypeButtonElement = document.createElement('a');
	}

	if (this.options.showPopup || kavel.woningtypeUrl) {
		woningtypeButtonElement.setAttribute('class', 'infowindow-button-woningtype button');
		woningtypeButtonElement.setAttribute('data-kavel', kavel.bouwnummer);
		woningtypeButtonElement.appendChild(document.createTextNode('Bekijk deze woning'));
	}

	if (this.options.showPopup) {
		woningtypeButtonElement.addEventListener('click', this.openFullInfoWindow);
	} else if (kavel.woningtypeUrl) {
		woningtypeButtonElement.setAttribute('href', kavel.woningtypeUrl);
	}

	if (woningtypeButtonElement) {
		innerContentElement.appendChild(woningtypeButtonElement);
	}

	this.infoWindowElement.appendChild(innerContentElement);

	this.closeInfoWindowElement = document.createElement('button');
	this.closeInfoWindowElement.setAttribute('class', 'infowindow-close');

	this.infoWindowElement.appendChild(this.closeInfoWindowElement);

	this.closeInfoWindowElement.addEventListener('click', this.deactivateInfoWindow);
};

SituatieKaart.prototype.createInfoRow = function (label, data, prepend, append, className) {
	var trElement1 = document.createElement('tr');
	if (className) {
		trElement1.setAttribute('class', className.toLowerCase());
	}
	var tdElement1 = document.createElement('th');
	tdElement1.appendChild(document.createTextNode(label));
	var tdElement2 = document.createElement('td');
	tdElement2.appendChild(document.createTextNode(data));
	if (prepend) {
		if (Array.isArray(prepend)) {
			for (var i = 0; i < prepend.length; i++) {
				tdElement2.insertBefore(prepend[i], tdElement2.firstChild);
			}
		} else {
			tdElement2.insertBefore(prepend, tdElement2.firstChild);
		}
	}
	if (append) {
		if (Array.isArray(append)) {
			for (var i = 0; i < append.length; i++) {
				tdElement2.appendChild(append[i]);
			}
		} else {
			tdElement2.appendChild(append);
		}
	}

	trElement1.appendChild(tdElement1);
	trElement1.appendChild(tdElement2);

	return trElement1;
};

SituatieKaart.prototype.openFullInfoWindow = function (e) {
	if (e && e.target) {
		var target = e.target;
	} else if (e && e.srcElement) {
		var target = e.srcElement;
	}

	while (target.nodeName.toLowerCase() != 'button') {
		if (target == this.fullInfoWindowElement) {
			return;
		}
		if (target == this.htmlElements.mapElement || target == this.closeInfoWindowElement) {
			this.deactivateInfoWindow();

			return;
		}
		target = target.parentNode;
	}

	var kavelNo = target.getAttribute('data-kavel').toLowerCase();
	var kavelNoFound = false;
	for (var i = 0; i < this.bouwnummers.length; i++) {
		if (this.bouwnummers[i].data.bouwnummer) {
			var infoKavelNo = this.bouwnummers[i].data.bouwnummer.toLowerCase();
		}
		if (infoKavelNo && kavelNo == infoKavelNo) {
			this.fillFullInfoWindow(this.bouwnummers[i].data);
			kavelNoFound = true;
		}
	}

	this.fullInfoWindowElement.classList.add('is-active');
	this.fullInfoWindowBackgroundElement.classList.add('is-active');

	var offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
	this.fullInfoWindowElement.setAttribute('style', 'top: ' + offset + 'px;');
};

//TODO: function to long, needs refactor
SituatieKaart.prototype.fillFullInfoWindow = function (kavel) {
	while (this.fullInfoWindowElement.firstChild) {
		this.fullInfoWindowElement.removeChild(this.fullInfoWindowElement.firstChild);
	}

	var contentElement = document.createElement('div');
	contentElement.setAttribute('class', 'kavelkaart-fullinfowindow-content');

	var headerElement = document.createElement('div');
	headerElement.setAttribute('class', 'kavelkaart-fullinfowindow-title');
	headerElement.appendChild(document.createTextNode('Kenmerken'));
	contentElement.appendChild(headerElement);

	var contentContainerElement = document.createElement('div');
	contentContainerElement.setAttribute('class', 'kavelkaart-fullinfowindow-content-container');

	var tableElement = document.createElement('table');
	tableElement.setAttribute('class', 'kavelkaart-fullinfowindow-bouwnummerinfo');

	if (kavel.bouwnummer && this.options.fieldsPopup.indexOf('bouwnummer') >= 0) {
		tableElement.appendChild(this.createInfoRow('Bouwnummer', kavel.bouwnummer));
	}
	if (kavel.woningtype) {
		tableElement.appendChild(this.createInfoRow('Woningtype', kavel.woningtype));
	}
	if (kavel.woningsoort && this.options.fieldsPopup.indexOf('woningsoort') >= 0) {
		tableElement.appendChild(this.createInfoRow('Woningsoort', kavel.woningsoort));
	}

	if (kavel.kaveloppervlakte && this.options.fieldsPopup.indexOf('kaveloppervlakte') >= 0) {
		var elementArray = [];
		var supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('2'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Kaveloppervlakte', kavel.kaveloppervlakte, false, elementArray));
	}
	if (kavel.woonoppervlakte && this.options.fieldsPopup.indexOf('woonoppervlakte') >= 0) {
		var elementArray = [];
		var supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('2'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Woonoppervlakte', kavel.woonoppervlakte, false, elementArray));
	}
	if (kavel.gebruikoppervlakte && this.options.fieldsPopup.indexOf('gebruikoppervlakte') >= 0) {
		var elementArray = [];
		var supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('2'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Gebruiksoppervlakte', kavel.gebruikoppervlakte, false, elementArray));
	}
	if (kavel.inhoud && this.options.fieldsPopup.indexOf('inhoud') >= 0) {
		var elementArray = [];
		var supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('3'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Inhoud', kavel.inhoud, false, elementArray));
	}
	if (kavel.tuinligging && kavel.woningsoort && kavel.woningsoort.toLowerCase() == 'appartement') {
		tableElement.appendChild(this.createInfoRow('Oriëntatie buitenruimte', kavel.tuinligging));
	} else if (kavel.tuinligging) {
		tableElement.appendChild(this.createInfoRow('Tuinligging', kavel.tuinligging));
	}

	if (kavel.prijsVan && kavel.prijsTot && this.options.fieldsPopup.indexOf('prijsbereik') >= 0) {
		tableElement.appendChild(this.createInfoRow('Prijsrange', '€ ' + kavel.prijsVan + ' - € ' + kavel.prijsTot));
	} else if (kavel.extra && this.options.fieldsPopup.indexOf('prijsbereik') >= 0) {
		tableElement.appendChild(this.createInfoRow('Prijsrange', kavel.extra));
	}

	if (parseInt(kavel.prijs) > 0 && this.options.fieldsPopup.indexOf('prijs') >= 0) {
		tableElement.appendChild(this.createInfoRow('Prijs', '€ ' + kavel.prijs + ',- v.o.n.'));
	}
	/*if(kavel.status){
 	tableElement.appendChild(this.createInfoRow('Status', kavel.status, false, false, kavel.status.replace(/ /gi, '_')));
 }*/

	contentContainerElement.appendChild(tableElement);

	this.carouselSlider = false;

	var images = kavel.images ? kavel.images : kavel.woningtypeImages;

	if (images && CarouselSlider) {
		var carouselElement = document.createElement('div');
		carouselElement.setAttribute('class', 'kavelkaart-fullinfowindow-carousel');

		var carouselIndicatorElement = document.createElement('div');
		carouselIndicatorElement.setAttribute('class', 'kavelkaart-fullinfowindow-indicator');
		carouselElement.appendChild(carouselIndicatorElement);

		var carouselSlidesElement = document.createElement('div');
		carouselSlidesElement.setAttribute('class', 'kavelkaart-fullinfowindow-slides');
		carouselElement.appendChild(carouselSlidesElement);

		for (var i = 0; i < images.length; i++) {
			if (kavel.woningtypeImage && kavel.woningtypeImage.url == images[i].url || kavel.image && kavel.image.url == images[i].url) {
				continue;
			}

			var slideElement = document.createElement('img');
			slideElement.setAttribute('class', 'kavelkaart-fullinfowindow-slide');
			slideElement.setAttribute('src', images[i].url);
			carouselSlidesElement.appendChild(slideElement);
		}

		var options = {
			'autoDelay': 6000
		};

		this.carouselSlider = new CarouselSlider(carouselElement, options, carouselSlidesElement, carouselIndicatorElement, false, true);

		contentContainerElement.appendChild(carouselElement);
	}

	if (kavel.omschrijvingHtml && kavel.omschrijvingHtml.trim().length > 0) {
		var omschrijvingContainer = document.createElement('div');
		omschrijvingContainer.setAttribute('class', 'kavelkaart-fullinfowindow-description');

		var omschrijvingHtml = this.stripScripts(kavel.omschrijvingHtml);
		omschrijvingContainer.innerHTML = omschrijvingHtml;

		contentContainerElement.appendChild(omschrijvingContainer);
	}

	//documenten
	if (this.options.showDocuments) {
		var documenten = [];

		if (kavel.woningtypeDocumenten) {
			var documenten = documenten.concat(kavel.woningtypeDocumenten);
		}

		if (kavel.woningDocumenten) {
			var documenten = documenten.concat(kavel.woningDocumenten);
		}

		if (kavel.projectDocumenten) {
			var documenten = documenten.concat(kavel.projectDocumenten);
		}

		if (documenten) {
			//console.log(documenten);
			var documentenContainerElement = document.createElement('div');
			documentenContainerElement.setAttribute('class', 'kavelkaart-fullinfowindow-documents');

			var docWoningtypesTitleElement = document.createElement('div');
			docWoningtypesTitleElement.setAttribute('class', 'kavelkaart-fullinfowindow-title');

			docWoningtypesTitleElement.appendChild(document.createTextNode('Downloads'));

			documentenContainerElement.appendChild(docWoningtypesTitleElement);

			var docWoningtypesListElement = document.createElement('ul');
			docWoningtypesListElement.setAttribute('class', 'kavelkaart-fullinfowindow-documents-container');

			for (var i = 0; i < documenten.length; i++) {
				var docWoningtypesListItem = document.createElement('li');
				docWoningtypesListItem.setAttribute('class', 'kavelkaart-fullinfowindow-documents-item');

				var docWoningtypesListItemLink = document.createElement('a');
				docWoningtypesListItemLink.setAttribute('title', documenten[i].bestandsnaam);
				docWoningtypesListItemLink.setAttribute('href', documenten[i].url);
				docWoningtypesListItemLink.setAttribute('target', '_blank');

				var name = documenten[i].bestandsnaam;
				if (documenten[i].titel) {
					name = documenten[i].titel;
				}

				docWoningtypesListItemLink.appendChild(document.createTextNode(name));

				docWoningtypesListItem.appendChild(docWoningtypesListItemLink);

				/*var docTypeElement = document.createElement('span');
    docTypeElement.setAttribute('class', 'kavelkaart-fullinfowindow-documents-item-type');
    docTypeElement.appendChild(document.createTextNode(documenten[i].type));
    	docWoningtypesListItem.appendChild(docTypeElement);*/

				docWoningtypesListElement.appendChild(docWoningtypesListItem);
			}

			documentenContainerElement.appendChild(docWoningtypesListElement);

			contentContainerElement.appendChild(documentenContainerElement);
		}
	}

	contentElement.appendChild(contentContainerElement);

	//button selecteer woning
	if (this.options.buttonPopup) {
		var buttonElement = document.createElement('a');
		buttonElement.setAttribute('class', 'button kavelkaart-fullinfowindow-button');
		buttonElement.setAttribute('data-buttontype', 'woningvoorkeur');
		buttonElement.setAttribute('data-bouwnummer', kavel.bouwnummer);

		if (this.options.buttonPopup.target) {
			buttonElement.setAttribute('target', this.options.buttonPopup.target);
		}

		if (kavel.uuid) {
			var id = kavel.uuid;
		} else {
			var id = kavel.bouwnummer;
		}

		var urlParts = this.options.buttonPopup.link.split('#');
		if (urlParts.length > 1) {
			var hash = urlParts[urlParts.length - 1];

			urlParts.splice(urlParts.length - 1, 1);
			var url = urlParts.join();
			var url = url.replace(/\/$/, '') + '?bouwnummer=' + id + '#' + hash;
		} else {
			var url = this.options.buttonPopup.link + '?bouwnummer=' + id;
		}

		buttonElement.setAttribute('href', url);
		buttonElement.appendChild(document.createTextNode(this.options.buttonPopup.text));

		contentElement.appendChild(buttonElement);
	}

	var closeElement = document.createElement('button');
	closeElement.setAttribute('class', 'kavelkaart-fullinfowindow-close');
	closeElement.addEventListener('click', this.removeFullInfoWindow);
	contentElement.appendChild(closeElement);

	this.fullInfoWindowElement.appendChild(contentElement);
};

SituatieKaart.prototype.removeFullInfoWindow = function (e) {
	this.fullInfoWindowElement.classList.remove('is-active');
	this.fullInfoWindowBackgroundElement.classList.remove('is-active');
};

SituatieKaart.prototype.changeLegenda = function (e) {
	if (e && e.target) {
		var target = e.target;
	} else if (e && e.srcElement) {
		var target = e.srcElement;
	}

	while (target && !target.classList.contains('legenda-status')) {
		target = target.parentNode;
	}

	if (!target.classList.contains('legenda-status')) {
		return;
	}

	target.classList.toggle('is-active');

	for (var i = 0; i < this.bouwnummers.length; i++) {
		if (target.getAttribute('data-status') == this.bouwnummers[i].element.getAttribute('data-status')) {
			if (this.bouwnummers[i].element.classList && target.classList.contains('is-active') && !this.bouwnummers[i].element.classList.contains('is-active')) {
				this.bouwnummers[i].element.classList.add('is-active');
			} else if (this.bouwnummers[i].element.classList) {
				this.bouwnummers[i].element.classList.remove('is-active');
			} else if (target.getAttribute('class').match(/is-active/) && !this.bouwnummers[i].element.getAttribute('class').match('/is-active/')) {
				this.bouwnummers[i].element.setAttribute('class', this.bouwnummers[i].element.getAttribute('class') + ' is-active');
			} else {
				this.bouwnummers[i].element.setAttribute('class', this.bouwnummers[i].element.getAttribute('class').replace(/is-active/, ''));
			}
		}
	}
};

//TODO: function to long, needs refactor
SituatieKaart.prototype.openViewer = function () {
	this.viewerElement = document.createElement('div');
	this.viewerElement.setAttribute('class', 'lightbox-viewer is-active kavelkaart');

	this.htmlElements.mapElement.setAttribute('style', 'background-image: url(\'' + this.htmlElements.kaartElement.getAttribute('data-href') + '\')');

	var imgElement = document.createElement('img');

	imgElement.addEventListener('load', function (event) {

		if (window.innerWidth && window.innerWidth < this.options.layoutSwitchWidth) {

			this.mapWidth = event.target.width * .5;
			this.mapHeight = event.target.height * .5;

			this.htmlElements.mapElement.getElementsByTagName('svg')[0].setAttribute('width', this.mapWidth);
			this.htmlElements.mapElement.getElementsByTagName('svg')[0].setAttribute('height', this.mapHeight);
			this.htmlElements.mapElement.getElementsByTagName('svg')[0].setAttribute('x', 0);
			this.htmlElements.mapElement.getElementsByTagName('svg')[0].setAttribute('y', 0);

			window.addEventListener('resize', this.onResize);
			this.onResize();
		} else {
			if (this.htmlElements.kaartElement.getAttribute('data-interactievekaart')) {
				this.htmlElements.mapElement.setAttribute('style', 'background-image: url(\'' + this.htmlElements.kaartElement.getAttribute('data-interactievekaart') + '\');');
			} else {
				this.htmlElements.mapElement.setAttribute('style', 'background-image: url(\'' + this.htmlElements.kaartElement.getAttribute('data-href') + '\');');
			}
		}
	}.bind(this), false);

	if (this.htmlElements.kaartElement.getAttribute('data-interactievekaart')) {
		imgElement.setAttribute('src', this.htmlElements.kaartElement.getAttribute('data-interactievekaart'));
	} else {
		imgElement.setAttribute('src', this.htmlElements.kaartElement.getAttribute('data-href'));
	}

	//infowindow aanmaken
	this.infoWindowElement = document.createElement('div');
	this.infoWindowElement.setAttribute('class', 'infowindow');

	this.htmlElements.navigationElement.appendChild(this.infoWindowElement);

	if (window.innerWidth && window.innerWidth < this.options.layoutSwitchWidth) {

		this.viewerElement.appendChild(this.htmlElements.mapElement);

		this.viewerElement.addEventListener('click', function (e) {
			if (e.target == this.viewerElement) {
				this.removeViewer();
			}
		}.bind(this), false);

		var closeElement = document.createElement('button');
		closeElement.setAttribute('class', 'lightbox-viewer-button-close');
		closeElement.addEventListener('click', this.removeViewer);
		this.viewerElement.appendChild(closeElement);

		this.viewerElement.appendChild(this.htmlElements.navigationElement);

		document.body.appendChild(this.viewerElement);
	} else {
		this.htmlElements.kaartElement.classList.contains('is-active');

		while (this.htmlElements.kaartElement.firstChild) {
			this.htmlElements.kaartElement.removeChild(this.htmlElements.kaartElement.firstChild);
		}
		this.htmlElements.kaartElement.appendChild(this.htmlElements.mapElement);
	}

	//legenda aanmaken
	if (this.options.showLegenda) {
		var legendaIndex = [];
		for (var i = 0; i < this.bouwnummers.length; i++) {
			var currentValue = this.bouwnummers[i].data.status;
			var found = false;
			for (var j = 0; j < legendaIndex.length; j++) {
				if (legendaIndex[j].toLowerCase() == currentValue.toLowerCase()) {
					found = true;
				}
			}

			if (!found && currentValue) {
				legendaIndex.push(this.bouwnummers[i].data.status);
			}
		}

		if (legendaIndex.length > 0) {
			this.legendaElement = document.createElement('div');
			this.legendaElement.setAttribute('class', 'legenda');

			var ulElement = document.createElement('ul');
			for (var i = 0; i < legendaIndex.length; i++) {
				var liElement = document.createElement('li');

				var labelElement = document.createElement('span');
				labelElement.setAttribute('class', 'legenda-status-label');
				labelElement.appendChild(document.createTextNode(legendaIndex[i]));

				liElement.appendChild(labelElement);

				var className = legendaIndex[i].toLowerCase().replace(/\s+/g, '-').replace(/\(/g, '').replace(/\)/g, '');
				liElement.setAttribute('class', 'legenda-status ' + className);
				liElement.setAttribute('data-status', legendaIndex[i].toLowerCase());
				ulElement.appendChild(liElement);

				liElement.addEventListener('click', this.changeLegenda);
			}

			this.legendaElement.appendChild(ulElement);
			this.htmlElements.navigationElement.appendChild(this.legendaElement);
		}
	}
};

SituatieKaart.prototype.onResize = function () {
	if (this.viewerElement.offsetWidth > this.mapWidth) {
		var width = ' margin-left: -' + this.mapWidth / 2 + 'px; left: 50%; width: ' + this.mapWidth + 'px;';
	} else {
		var width = 'left: 0; width: ' + this.mapWidth + 'px;';
	}
	if (this.viewerElement.offsetHeight > this.mapHeight) {
		var height = ' margin-top: -' + this.mapHeight / 2 + 'px; top: 50%; height: ' + this.mapHeight + 'px;';
	} else {
		var height = 'top: 0; height: ' + this.mapHeight + 'px;';
	}

	if (this.htmlElements.kaartElement.getAttribute('data-interactievekaart')) {
		this.htmlElements.mapElement.setAttribute('style', 'background-image: url(\'' + this.htmlElements.kaartElement.getAttribute('data-interactievekaart') + '\');' + width + height);
	} else {
		this.htmlElements.mapElement.setAttribute('style', 'background-image: url(\'' + this.htmlElements.kaartElement.getAttribute('data-href') + '\');' + width + height);
	}
};

SituatieKaart.prototype.onResizeLayout = function () {
	if (window.innerWidth && window.innerWidth < this.options.layoutSwitchWidth && this.currentLayout == 'large' || window.innerWidth && window.innerWidth > this.options.layoutSwitchWidth && this.currentLayout == 'small') {
		window.location.href = window.location.href; //simpele fix maar kan beter
	}
};

SituatieKaart.prototype.removeViewer = function () {
	this.viewerElement.parentNode.removeChild(this.viewerElement);
	this.infoWindowElement.parentNode.removeChild(this.infoWindowElement);
	this.viewerElement = null;
	this.infoWindowElement = null;
};

SituatieKaart.prototype.stripScripts = function (htmlString) {
	var div = document.createElement('div');
	div.innerHTML = htmlString;
	var scripts = div.getElementsByTagName('script');
	var i = scripts.length;
	while (i--) {
		scripts[i].parentNode.removeChild(scripts[i]);
	}
	return div.innerHTML;
};